import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export class ConfirmActionButton {

  identifier: string;
  displayText: string;
  returnObj: any;
  color: string;
  raised: boolean;

  constructor(identifier: string, displayText: string, returnObj: any, color: string, raised: boolean) {
    this.identifier = identifier;
    this.displayText = displayText;
    this.returnObj = returnObj;
    this.color = color;
    this.raised = raised;
  }

}

export class ConfirmEvent {

  eventType: string;
  eventIdentifier: string;
  eventPayload: any;

  constructor(eventType: string, eventIdentifier: string, eventPayload) {
    this.eventType = eventType;
    this.eventIdentifier = eventIdentifier;
    this.eventPayload = eventPayload;
  }

}

@Component({
  standalone: false,
  selector: 'app-general-confirm',
  templateUrl: './general-confirm.component.html',
  styleUrls: ['./general-confirm.component.css']
})
export class GeneralConfirmComponent implements OnInit {

  message: string = '';
  actionButtons: ConfirmActionButton[] = [];
  inlineButtons: boolean = true;

  constructor(
    public dialogRef: MatDialogRef<GeneralConfirmComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  ngOnInit() {
    this.message = this.data.message;
    this.actionButtons = this.data.actionButtons;
    this.inlineButtons = this.data.inlineButtons;
  }

  onActionButtonPressed(actionButton: ConfirmActionButton) {
    let event = new ConfirmEvent('click', actionButton.identifier, actionButton.returnObj);
    this.dialogRef.close(event);
  }



}
